import { QuestionAnswer } from "@/components/examinee/interview/Types";

export function getRightCount(answers: QuestionAnswer[]): number {
  return answers.reduce((prev, current) => {
    return current.answers[0].answer.includes("[正解]") ? ++prev : prev;
  }, 0);
}
